<template>
  <div class="visitor-login">
    <div class="visitor-login-box">
      <template v-for="(item, index) in thirdList">
        <div v-if="loginHref[item]" :key="index" class="third-box">
          <div
            class="login-type"
            :class="`j-${item}-login-btn`"
            @click="loginHrefJump(loginHref[item], item)"
          >
            <em :class="item" :title="channelName[item]"></em>
            <span> {{ channelName[item] }}</span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import login from '@mixins/officialTopupNew/login';
import { CHANNEL_NAME } from '@store/officialTopupNew/login';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV35';
export default {
  name: 'VisitorLogin',
  mixins: [login],
  data() {
    return {
      channelName: CHANNEL_NAME
    };
  },
  computed: {
    ...mapState({
      gameId: state => state.gameId
    })
  },
  watch: {
    gameId: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          return;
        }
        this.getThirdPartyLogin();
      }
    }
  },
  methods: {
    loginHrefJump(href, loginType) {
      clickButton({
        btnName: 'third_login_clike',
        locationKey: locationType.loginPopup,
        otherParams: {
          loginType: loginType
        }
      });
      window.open(href, '_self');
    }
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialTopupNew/_dimen.scss';
.visitor-login {
  &-box {
    box-sizing: border-box;
    padding: 0 40px;

    .third-box {
      display: inline-block;
      width: 100%;
      height: 80px;
      background-color: #ffffff;
      border-radius: 6px;
      border: solid 1px #e8e8e8;
      margin-bottom: 20px;

      .login-type {
        height: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: auto 25px auto;
        font-size: 24px;
        color: #333333;
      }
    }

    @each $icon in facebook, twitter, kakao, line, naver, googleplay, apple, vk
    {
      .#{$icon} {
        background: url($commonLoginImg + 'icon-' + $icon + '.png')
          no-repeat
          center
          center;
        background-size: contain;
        position: absolute;
        left: 0;
        width: 36px;
        height: 80px;
        display: block;
        transition: all 0.2s;
      }
    }
  }
}
</style>
